import styled from 'styled-components';

export const CopyrightWrapper = styled.section`
  padding: 15px;
  background-color: ${(props) => props.theme.color.lightBlue};
  text-align: center;
`;
